import {
  REAL_ESTATE_CATEGORY_OPTIONS,
  LISTING_TYPE_OPTIONS,
  LISTING_PROCESSING_STATUS_OPTIONS,
  POSTER_TYPE,
  HISTORY_OPTIONS,
  REQUEST_TYPE_OPTIONS,
  landUseCodes,
} from './../constants/realestate.const'

const getRealestateType = (type: string) => {
  return REAL_ESTATE_CATEGORY_OPTIONS.find((option) => option.value === type).label
}

export const formatTableDataRealestate = (data: any[]) => {

  return data.map((item) => {
    const type = item.information?.symbol?.split('+').map((symbol: string) =>
      landUseCodes.find((code) => code.code.trim() === symbol.trim())?.description || symbol,
    ).join(', ') || item.information?.symbol || '';
    console.log(20, item);
    try {
      const parsedItem = {
        ...item,
        code: item.id,
        land_type: [
          {
            type: item.land_type ? 'info' : 'danger',
            label: item.land_type || 'Không xác định',
            // label: landUseCodes.find((code) => code.code === item.information?.symbol)?.description || item.information?.symbol || '',
            // label: item.information?.symbol || ''
          },
        ],
        region_lv1: item.province?.name,
        region_lv2: item.ward?.name,
        area: item.area,
        map_sheet_number: item.map_sheet_number,
        plot_number: item.plot_number,
        address: item.address || '',
        coords: {
          item: item,
          title: [
            item.real_estate?.address || item.address,
            item.district?.name,
            item.province?.name,
          ].join(', '),
          center: {
            lat: item.centroid?.coordinates[1],
            lng: item.centroid?.coordinates[0],
          },
          coordinates: item.wgs84_coordinates?.coordinates[0],
        },
        fist_listing_at: item.first_listing_date || '',
        created_at: item.created_at,
      }
      console.log(55, parsedItem);
      return parsedItem;
    } catch (error) {
      console.log(59, error);
    }
  })
}

export const formatTableDataListing = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    id: item.id,
    code: item.id,
    action: [
      {
        type: REQUEST_TYPE_OPTIONS.find((option) => option.value === item.request_type)?.color,
        label: REQUEST_TYPE_OPTIONS.find((option) => option.value === item.request_type)?.label,
      },
    ],
    type: [
      {
        type: LISTING_TYPE_OPTIONS.find((option) => option.value === item.listing_type)?.color,
        label: LISTING_TYPE_OPTIONS.find((option) => option.value === item.listing_type)?.label,
      },
      item.flash_offer_item_ongoing
        ? {
            type: 'danger',
            label: item.flash_offer_item_ongoing ? 'Flash Offer' : '',
          }
        : null,
    ].filter(Boolean),
    address: {
      region: `${item?.real_estate?.ward?.name}, ${item?.real_estate?.province?.name}`,
      address: item.address || item?.real_estate?.address,
    },
    subject: {
      thumb: item.photos?.[0]?.url?.thumbnail,
      title: item.title,
      attrs: [
        {
          key: 'Diện tích',
          val: item.area,
        },
      ],
      map: {
        map_sheet: item.map_sheet_number || item.real_estate?.map_sheet_number,
        plot_num: item.plot_number || item.real_estate?.plot_number,
      },
    },
    author:
      item.poster_type === POSTER_TYPE.USER
        ? {
            id: item.poster?.id,
            profile_pic: '',
            code: `#${item.poster?.code}`,
            full_name: item.poster?.full_name,
            phone: item.poster?.phone_number,
            email: item.poster?.email,
          }
        : {
            id: '',
            profile_pic: '',
            code: `#`,
            full_name: 'admin',
            phone: '',
            email: '',
          },
    statistic: [
      {
        key: 'Lượt xem',
        val: item.total_view,
      },
    ],
    status: [
      {
        type: LISTING_PROCESSING_STATUS_OPTIONS.find(
          (option) => option.value === item.processing_status,
        )?.color,
        label: LISTING_PROCESSING_STATUS_OPTIONS.find(
          (option) => option.value === item.processing_status,
        )?.label,
      },
    ],
    regdate: item.created_at,
  }))
}

export const formatTableDataHistory = (data: any[]) => {
  return data.map((item) => ({
    ...item,
    code: item.id,
    date: item.date,
    type: HISTORY_OPTIONS.find((option) => option.value === item.change_type)?.label || '',
    old_value: item.old_value || '',
    new_value: item.new_value || '',
    author: item.admin | '',
  }))
}
